const DEFAULT_ACCESS = {
  review: false,
  view: false,
  download: false,
  add: false,
  edit: false,
  delete: false,
  upload: false,
  chat: false,
};

function mapRightsToAccess(rights = {}) {
  return {
    ...DEFAULT_ACCESS,
    ...rights,
  };
}

export function modulesToMenuTree(modules) {
  if (!modules) {
    return [];
  }
  if (Array.isArray(modules)) {
    return modules;
  }

  return Object.values(modules).map((mod) => {
    const child =
      mod.child && typeof mod.child === 'object' && Object.keys(mod.child).length
        ? modulesToMenuTree(mod.child)
        : null;

    return {
      _id: mod._id,
      key: mod.key,
      label: mod.label,
      level: mod.level,
      is_leaf: mod.is_leaf,
      access: mod.access ? mapRightsToAccess(mod.access) : mapRightsToAccess(mod.rights),
      child,
    };
  });
}

export function extractMenuData(userData = {}) {
  if (userData.menus && userData.menus.length) {
    return userData.menus;
  }
  return modulesToMenuTree(userData.modules);
}

export function isUserEnabled(userData = {}) {
  if (userData.enable !== undefined && userData.enable !== null) {
    return Boolean(userData.enable);
  }
  if (userData.status !== undefined && userData.status !== null) {
    return Boolean(userData.status);
  }
  return true;
}

/** Maps user-mgmt v2 session payload to fields the Sensia UI still expects. */
export function normalizeUserData(userData = {}) {
  const normalized = { ...userData };

  if (normalized.username && !normalized.login_id) {
    normalized.login_id = normalized.username;
  }
  if (normalized.login_id && !normalized.username) {
    normalized.username = normalized.login_id;
  }

  if (normalized.enable === undefined) {
    normalized.enable = isUserEnabled(normalized);
  }

  if (!normalized.role && Array.isArray(normalized.roles) && normalized.roles.length) {
    normalized.role = normalized.roles[0].label || normalized.roles[0].key || '';
  }

  if (normalized.first_name && !normalized.name) {
    normalized.name = normalized.first_name;
  } else if (normalized.name && !normalized.first_name) {
    const parts = String(normalized.name).trim().split(/\s+/);
    normalized.first_name = parts[0] || '';
    if (!normalized.last_name && parts.length > 1) {
      normalized.last_name = parts.slice(1).join(' ');
    }
  }

  const first = normalized.first_name || normalized.name || '';
  const last = normalized.last_name || '';
  normalized.full_name =
    normalized.full_name || `${first} ${last}`.trim() || normalized.name || '';

  if (normalized.group === undefined) {
    if (Array.isArray(normalized.groups) && normalized.groups.length) {
      normalized.group = normalized.groups[0].label || normalized.groups[0].key || '';
    } else {
      normalized.group = normalized.group || '';
    }
  }

  const menus = extractMenuData(normalized);
  if (menus.length) {
    normalized.menus = menus;
  }

  return normalized;
}

export function mergeUserSession(existing = {}, incoming = {}) {
  return normalizeUserData({ ...existing, ...incoming });
}
